/**
 * @generated SignedSource<<514fe16b031f4dfae297673efcc90b15>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAuctionActionBidLabel_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useAuctionBids_item">;
  readonly " $fragmentType": "PdpSharedAuctionActionBidLabel_item";
};
export type PdpSharedAuctionActionBidLabel_item$key = {
  readonly " $data"?: PdpSharedAuctionActionBidLabel_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionActionBidLabel_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionActionBidLabel_item",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "fetchUser",
          "variableName": "fetchUser"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useAuctionBids_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "0ec455c26a1cbe75ec4a255ca7770ade";

export default node;
